import { ConfigTaskRoles } from '../../plugins/api'

export default {
  namespaced: true,
  state: {
    configTaskRoles: [],
    configTaskRolesByID: {},
  },
  mutations: {
    setConfigTaskRoles(state, configTaskRoles) {
      state.configTaskRoles = configTaskRoles
    },
  },
  actions: {
    async fetchConfigTaskRoles({ commit }, options) {
      try {
        const listConfig = await ConfigTaskRoles.fetch(options)
        commit('setConfigTaskRoles', listConfig)
        return listConfig
      } catch (error) {
        console.error(error)
        return []
      }
    },
    async setConfigTaskRoles({ dispatch }, taskData) {
      try {
        await ConfigTaskRoles.create({ ...taskData })
        await dispatch('fetchConfigTaskRoles')
        return true
      } catch (error) {
        console.error('Cấu hình role công việc thất bại!')
        console.error(error)
        return false
      }
    },
    async deleteConfigTaskRoles({ dispatch }, id) {
      try {
        await ConfigTaskRoles.remove(id)
        await dispatch('fetchConfigTaskRoles')
        return true
      } catch (error) {
        console.error('Xóa role công việc thất bại!')
        console.error(error)
        return false
      }
    },
  },
  getters: {
    configs: state => state.configTaskRoles,
  },
}
